import { throttle, a11yClick } from './util';

(function(Drupal, $, once) {
  'use strict';

  const scrollClass = 'scroll-down';

  let Header = {
    lastScrollPos: 0,
  };

  Header.handleMediaQuery = (mq) => {
    if (mq.matches) {
      Header.handleScroll();
      jQuery(window).scroll(throttle(() => {
        Header.handleScroll();
      }, 150));
    }
    else {
      jQuery(window).off('scroll');
    }
  };

  Header.handleScroll = (event) => {
    const currentScrollPos = window.pageYOffset;

    // Scroll down
    if (
      currentScrollPos > Header.$header.height() &&
      currentScrollPos > Header.lastScrollPos &&
      !Header.$header.hasClass(scrollClass)
      ) {
      Header.$header.addClass(scrollClass);
    }
    else if (currentScrollPos < Header.lastScrollPos && Header.$header.hasClass(scrollClass)) {
      Header.$header.removeClass(scrollClass);
    }

    Header.lastScrollPos = currentScrollPos;
  };

  Drupal.behaviors.header = {
    attach: function(context, settings) {

      $(once('ctpf-header', 'body', context)).each(function() {
        let $body = jQuery(this);
        let $header = $body.find('.site-header');
        let $menuToggle = $header.find('.menu-toggle button');
        let $mainMenu = $header.find('.site-nav .menu--main .menu');
        let $menuItemsWithDropdown = $mainMenu.find('.menu-item--has-dropdown.menu-depth--0');
        let $translateSelect = $header.find('.gtranslate select');
        $translateSelect.attr('aria-label', 'Select a language for translation');

        Header.$header = $header;

        // media query event handler
        if (window.matchMedia) {
          const mq = window.matchMedia("(max-width: 1199px)");
          mq.addListener(Header.handleMediaQuery);
          Header.handleMediaQuery(mq);
        }

        $menuToggle.on('click keyup', function(event) {
          event.preventDefault();

          if (a11yClick(event) === true) {
            $body.toggleClass('menu-open');
            $menuToggle.toggleClass('is-active');
          }
        });

        $menuItemsWithDropdown.each(function() {
          let $thisMenuItem  = jQuery(this);
          let $thisMenuToggle = $thisMenuItem.find('.submenu-toggle');

          $thisMenuToggle.click(function(event) {
            $thisMenuItem.toggleClass('open');
          });
        });
      });
    }
  };

})(Drupal, jQuery, once);
